import { SxProps, Theme } from '@mui/material/styles';
import { FC, memo } from 'react';

import GenericLayout from '../../components/generic-layout/GenericLayout';
import Grid2 from '../../components/grid/Grid2';
import { H2 } from '../../components/heading/Hx';
import Img from '../../components/img/Img';
import List from '../../components/list/List';
import ListItem from '../../components/list/ListItem';
import Paragraph from '../../components/paragraph/Paragraph';
import Route from '../../components/route/Route';
import { RoutePath } from '../../components/route/type';
import NoPageImageSection from '../../components/section/NoPageImageSection';
import { COLOR } from '../../theme/type';

const SX_IMG: SxProps<Theme> = {
  borderRadius: '0.25rem',
  marginBottom: '0.25rem',
  maxWidth: '500px',
  width: '100%',
};

const SystemaRyabko: FC = () => (
  <GenericLayout title='Systema Ryabko'>
    <NoPageImageSection background={COLOR.Dark3}>
      <Grid2 spacing='2rem'>
        <Grid2.Item>
          <H2 color={COLOR.Gold1}>Systema Ryabko</H2>

          <Paragraph margin='0'>
            Systema Ryabko ist einer von vielen Systema Stilen. Seinen Ursprung hat es in Tver und
            Moskau. Gründer und Oberhaupt war Mikhail Ryabko, der leider im Jahr 2023 verstorben
            ist.
          </Paragraph>
          <Paragraph>
            Systema Ryabko wird heute vor allem von Daniil Ryabko (Moskau, Russland), dem Sohn von
            Mikhail, und von Vladimir Vasiliev (Toronto, Kanada) vertreten und unterrichtet. Weitere
            bekannte Meister sind Alexander Andreychenkov und Valentin Talanov (der mittlerweile
            Systema Talanov unterrichtet).
          </Paragraph>
          <Paragraph>
            Dieser Systema Stil setzt sehr stark auf die so genannten drei Grundsäulen: Atmung, Form
            und Zustand. Dabei werden verschiedene Grundübungen, wie etwa Liegestütze und Kniebeugen
            mit Atem-Übungen kombiniert. Weiterhin wird auf eine aufrechte Körperhaltung und einen
            bestimmten, ausgeglichenen psychischen Zustand Wert gelegt.
          </Paragraph>
          <Paragraph>
            Mikhail Ryabko war berühmt für seine tiefen Schläge, mit denen er erstaunliche Wirkungen
            hervor bringen konnte. So werden weiterhin sehr viele Schlagübungen und entsprechende
            Körpervorbereitungen und Regenerations-Methoden trainiert. Darüber hinaus wird viel
            gerollt und ausgewichen.
          </Paragraph>
          <Paragraph>
            Obwohl der Stil weich arbeitet, werden bestimmte wichtige Prinzipien leider
            vernachlässigt. So fehlt etwa die absolute Präzision, die stattdessen durch
            Ausweichbewegungen des Körpers oder Rollen ausgeglichen wird.
          </Paragraph>

          <Paragraph margin={{ bottom: '0.75em', top: '1.5rem' }}>
            <Route href={RoutePath.FalkoZander}>Falko Zander</Route> war Internationaler Ausbilder
            (2004-2015), Repräsentant für Deutschland (2014-2015) und hat bei folgenden Lehrern von
            Systema Ryabko gelernt:
          </Paragraph>
          <List bullets itemProps={{ margin: '0' }}>
            <ListItem>Mikhail Ryabko</ListItem>
            <ListItem>Alexander Andreychenkov</ListItem>
            <ListItem>Valentin Talanov</ListItem>
            <ListItem>Sergey Borshov</ListItem>
            <ListItem>Vladimir Vasiliev</ListItem>
            <ListItem>Daniil Ryabko</ListItem>
            <ListItem>Sergey Ozereliev</ListItem>
            <ListItem>Konstantin Komarov</ListItem>
          </List>
        </Grid2.Item>
        <Grid2.Centered>
          <Img
            alt='Mikhail Ryabko und Falko Zander in Augsburg, 2008'
            src='/img/img-mikhail-ryabko-falko-zander.jpg'
            sx={{ ...SX_IMG, marginTop: '0.25rem' }}
          />
          <Paragraph margin='0' variant='body2'>
            Mikhail Ryabko und Falko Zander in Augsburg, 2008
          </Paragraph>

          <Img
            alt='Daniil Ryabko und Falko Zander in Berlin, 2007'
            src='/img/img-daniil-ryabko-falko-zander.jpg'
            sx={{ ...SX_IMG, marginTop: '1rem' }}
          />
          <Paragraph margin='0' variant='body2'>
            Daniil Ryabko und Falko Zander in Berlin, 2007
          </Paragraph>
        </Grid2.Centered>
      </Grid2>
    </NoPageImageSection>
  </GenericLayout>
);

export default memo(SystemaRyabko);
